export const CREATIVE_ENGINE_TABS = {
  CreativeBriefs: 'creative-briefs',
  Avatars: 'avatars',
  CastingProfile: 'casting-profile'
} as const;

export type CreativeEngineTab = (typeof CREATIVE_ENGINE_TABS)[keyof typeof CREATIVE_ENGINE_TABS];
